<template>
  <div class="failed-log-page">
    <!-- 搜索条件 -->
    <div class="search-section">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="接收号码">
          <el-input v-model="searchForm.smsTo" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" class="search-btn">搜索</el-button>
          <el-button @click="handleReset" class="reset-btn">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 失败记录列表 -->
    <div class="records-section">
      <div class="section-title">
        <h3>失败记录</h3>
      </div>
      <el-table :data="failedRecords" style="width: 100%" class="custom-table">
        <el-table-column label="发送时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column prop="to" label="接收号码" width="120" />
        <el-table-column prop="reason" label="失败原因" width="300" />
        <el-table-column prop="content" label="发送内容" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          class="custom-pagination">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FailedLogPage',
  data() {
    return {
      searchForm: {
        smsTo: ''
      },
      failedRecords: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.fetchFailedRecords()
  },
  methods: {
    fetchFailedRecords() {
      this.$http.get('/sms/info/failed-messages', {
        params: {
          smsTo: this.searchForm.smsTo,
          pageNum: this.page.current,
          pageSize: this.page.size
        }
      }).then(res => {
        if (res.code === 200) {
          this.failedRecords = res.data.records
          this.page.total = res.data.total
        }
      })
    },
    handleSearch() {
      this.page.current = 1
      this.fetchFailedRecords()
    },
    handleReset() {
      this.searchForm = {
        smsTo: ''
      }
      this.page.current = 1
      this.fetchFailedRecords()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.fetchFailedRecords()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.fetchFailedRecords()
    }
  }
}
</script>

<style lang="scss" scoped>
.failed-log-page {
  box-sizing: border-box;
  padding: 20px;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  background: linear-gradient(135deg, #f6f8fc 0%, #eef1f8 100%);

  .search-section {
    background: white;
    padding: 20px;
    border-radius: 16px;
    margin-bottom: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

    .search-form {
      .el-form-item {
        margin-bottom: 0;
      }
    }

    :deep(.el-input__inner) {
      border-radius: 12px;
      border: 1px solid #e0e7ff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
      transition: all 0.3s;

      &:focus {
        border-color: #7366ff;
        box-shadow: 0 0 0 2px rgba(115, 102, 255, 0.2);
      }
    }

    :deep(.el-button) {
      border-radius: 12px;
      padding: 10px 20px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      font-weight: 500;
    }

    .search-btn {
      background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
      border: none;
      box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
      }
    }

    .reset-btn {
      background: #f8f9fa;
      border: 1px solid #e5e7eb;
      color: #4a5568;

      &:hover {
        background: #e9ecef;
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  .section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h3 {
      margin: 0;
      color: #1e293b;
      font-size: 18px;
      font-weight: 600;
      position: relative;
      padding-left: 12px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 18px;
        background: linear-gradient(to bottom, #7366ff, #a388ff);
        border-radius: 2px;
      }
    }
  }

  .records-section {
    background: white;
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

    .custom-table {
      margin-bottom: 20px;
      border-radius: 12px;
      overflow: hidden;

      :deep(.el-table__header-wrapper) {
        th {
          background: #f6f9fc;
          color: #1e293b;
          font-weight: 600;
          padding: 12px 0;
        }
      }

      :deep(.el-table__body-wrapper) {
        td {
          padding: 12px 0;
          color: #4a5568;
        }
      }

      :deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
        background-color: #f8f9ff;
      }

      :deep(.el-table__row) {
        transition: all 0.3s;
      }

      :deep(.el-table--striped .el-table__body tr.el-table__row--striped td) {
        background: #f9fafc;
      }
    }

    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;

      .custom-pagination {
        :deep(.el-pagination__total) {
          color: #4a5568;
        }

        :deep(.el-pagination__sizes) {
          margin-left: 16px;
        }

        :deep(.el-input__inner) {
          border-radius: 8px;
        }

        :deep(.el-pager li) {
          border-radius: 8px;
          margin: 0 3px;
          transition: all 0.3s;
        }

        :deep(.el-pager li.active) {
          background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
          color: white;
          box-shadow: 0 2px 5px rgba(115, 102, 255, 0.3);
        }

        :deep(.btn-prev, .btn-next) {
          border-radius: 8px;
        }
      }
    }
  }
}
</style> 